import {Owner, RegisteredUser, RoleId, Team, TeamId, TeamMin} from "../../Types";
import {declareModal} from "../../components/modals";
import {ConfirmationModalProps} from "./ConfirmationDialog";

type ReassignDialogProps = {
  onReassign: (owner?: Owner) => Promise<unknown>;
};

export const confirmationDialog = declareModal<ConfirmationModalProps>();
export const reassignUserDialog = declareModal<ReassignDialogProps>();
export const reassignTeamDialog = declareModal<ReassignDialogProps>();
export const inviteUserDialog = declareModal<{
  initialName?: string;
  initialEmail?: string;
  onInvite?: (user: RegisteredUser) => Promise<unknown>;
}>();
export const createEditTeamDialog = declareModal<{
  type: "Create" | "Edit";
  initialName?: string;
  team?: Team;
  onCreate?: (team: TeamMin) => Promise<unknown>;
}>();
export const addRoleMemberDialog = declareModal<{roleId: RoleId}>();
export const addTeamMemberDialog = declareModal<{teamId: TeamId}>();
